import { render, staticRenderFns } from "./DataTableEager.vue?vue&type=template&id=2259acf0&scoped=true&"
import script from "./DataTableEager.vue?vue&type=script&lang=js&"
export * from "./DataTableEager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259acf0",
  null
  
)

export default component.exports